<template>
  <div>
    <heading :helpInfo="sidebarCard">
      {{ $t("sidebar.riskAssessment") }}
    </heading>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs"></v-breadcrumbs>
    <riskAssessmentTable />
  </div>
</template>

<script>
import riskAssessmentTable from "@/views/riskAssessment/riskAssessmentTable.vue";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
import i18n from "../../i18n";

export default {
  name: "riskAssessment",
  components: { riskAssessmentTable },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "de") {
        return sidebarTextDE.default.riskAssessment;
      } else if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.riskAssessment;
      }
      return sidebarTextDE.default.riskAssessment;
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("riskAssessment.category.breadcrumbs.name"),
          disabled: false,
          href: `/app/riskAssessmentCategory`,
        },
        {
          text: this.title,
          disabled: true,
        },
      ];
    },
  },
  data() {
    return {
      title: "",
    };
  },
  mounted() {
    this.title = this.$route.params.riskAssessmentCategoryName;
  },
};
</script>
